export const getTrackCashRequestApprovals = (state) =>
  state.trackCashRequestApprovals.results;